<template>
    <div class="flex flex-col items-center justify-center flex-grow">
        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

        <h2 class="text-text mb-4">
            {{ $lang.get('Log in to :sitename', { sitename: sitename }) }}
        </h2>
        <p class="text-text mb-8 font-header max-w-xl w-full text-center">
            {{ $lang.get("If you don't have an account") }},
            <Link
                :href="route('register')"
                class="underline underline-offset-2 decoration-2"
                v-text="$lang.get('register for free')"
            />
            <span v-if="subtext" v-text="', ' + subtext" />
        </p>

        <form
            @submit.prevent="submit"
            class="max-w-xl w-full bg-white px-6 py-4 rounded-card border border-border shadow mb-4"
        >
            <div>
                <TextInput
                    v-model="form.email"
                    :label="$lang.get('Email')"
                    :error="form.errors.email"
                    id="email"
                    type="email"
                    class="mt-1 block w-full"
                    autocomplete="username"
                    :required="true"
                    autofocus
                />
            </div>

            <div class="mt-4">
                <PasswordInput
                    id="password"
                    :error="form.errors.password"
                    :label="$lang.get('Password')"
                    v-model="form.password"
                />
            </div>

            <div class="block mt-4">
                <Checkbox
                    id="remember"
                    :label="$lang.get('Remember me')"
                    name="remember"
                    v-model:checked="form.remember"
                />
            </div>

            <div class="flex items-center justify-between mt-4 font-header">
                <Link
                    v-if="canResetPassword"
                    :href="route('password.request')"
                    class="underline-hover text-text-secondary"
                    v-text="$lang.get('Forgot your password?')"
                />

                <div>
                    <Link
                        :href="route('register')"
                        v-text="$lang.get('Register')"
                        class="text-text-secondary underline-hover"
                    />
                    <PrimaryButton
                        type="submit"
                        class="ms-4"
                        weight="font-semibold"
                        :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing"
                        :roundedPill="false"
                        v-text="$lang.get('Login')"
                    />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Checkbox from '@/Components/FormElements/Checkbox.vue'
import InputError from '@/Components/FormElements/InputError.vue'
import InputLabel from '@/Components/FormElements/InputLabel.vue'
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import TextInput from '@/Components/FormElements/TextInput.vue'
import PasswordInput from '@/Components/FormElements/PasswordInput.vue'
import { Link, useForm } from '@inertiajs/vue3'

export default {
    components: {
        Checkbox,
        InputError,
        InputLabel,
        PrimaryButton,
        TextInput,
        PasswordInput,
        Link,
    },

    props: {
        canResetPassword: {
            type: Boolean,
        },
        status: {
            type: String,
        },
        sitename: {
            type: String,
        },
        subtext: {
            type: [String, null],
            default: null,
        },
    },

    data() {
        return {
            form: useForm({
                email: '',
                password: '',
                remember: false,
            }),
        }
    },

    methods: {
        submit() {
            this.form.post(route('login'), {
                preserveScroll: true,
                onFinish: () => this.form.reset('password'),
            })
        },
    },
}
</script>
